import { computed, ComputedRef } from "vue";
import { useRoute } from "vue-router";
import { config } from "../../config/config";
import { ReservationType } from "../../reservation/enum.reservationType";

export type BackToReservationOrRequest = {
  type: ReservationType;
  link: string;
};

export function getEassistantReservationEditUrl(reservationId: null | undefined | number | string): null | string {
  if (reservationId === null || reservationId === undefined || !config.eassistantProductionUrl) {
    return null;
  }
  const id = typeof reservationId === "string" ? reservationId.trim() : String(reservationId);
  if (id === "") {
    return null;
  }
  return `${config.eassistantProductionUrl}/Reservation/Edit/${id}`;
}

export const backToReservationOrRequestData: ComputedRef<null | BackToReservationOrRequest> = computed(() => {
  const route = useRoute();
  const rawReservationId = route?.query["reservationId"];
  const reservationIdParam = Array.isArray(rawReservationId) ? rawReservationId[0] : rawReservationId;
  const link = getEassistantReservationEditUrl(reservationIdParam);
  if (!link) {
    return null;
  }
  return {
    type: Number(route.query["reservationType"]) as ReservationType,
    link,
  };
});
